import { memo } from 'react';

import { OSelect } from '@src/shared';

import { QUESTION_FILTERS, SORT_OPTIONS } from '@src/constants';

import { IQuestionAndAnswerFiltersProps } from '@src/types';

import styles from './questionAndAnswerFilters.module.scss';

const QuestionAndAnswerFilters = ({
  showValue,
  sortValue,
  onShowChange,
  onSortChange,
  currentPeerType,
}: IQuestionAndAnswerFiltersProps) => {
  return (
    <div className={styles.filtersContainer}>
      <OSelect
        label="Show"
        items={QUESTION_FILTERS[currentPeerType]}
        onChange={onShowChange}
        selectedValue={showValue}
        size="x-small"
        classes={{
          customLabel: styles.customLabel,
        }}
      />
      <OSelect
        label="Sort by"
        items={SORT_OPTIONS}
        onChange={onSortChange}
        selectedValue={sortValue}
        size="x-small"
        classes={{
          customLabel: styles.customLabel,
        }}
      />
    </div>
  );
};

export default memo(QuestionAndAnswerFilters);
